import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Chip,
  Button,
  Divider,
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { format } from 'date-fns';

function PageViewer({ page, onEdit }) {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      return format(new Date(dateString), 'MMM d, yyyy h:mm a');
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateString;
    }
  };
  
  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <Typography variant="h4" gutterBottom>
          {page.title}
        </Typography>
        
        {onEdit && (
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={onEdit}
          >
            Edit
          </Button>
        )}
      </Box>
      
      {page.category && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Category: {page.category.name}
          </Typography>
        </Box>
      )}
      
      {page.tags && page.tags.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
          {page.tags.map(tag => (
            <Chip key={tag} label={tag} size="small" />
          ))}
        </Box>
      )}
      
      <Divider sx={{ mb: 3 }} />
      
      <Box 
        sx={{ mb: 4 }}
        className="ql-editor"
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
      
      <Divider sx={{ mb: 2 }} />
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
        <Typography variant="caption" color="text.secondary">
          Created by {page.createdBy?.firstName} {page.createdBy?.lastName} on {formatDate(page.createdAt)}
        </Typography>
        
        {page.updatedAt && page.updatedAt !== page.createdAt && (
          <Typography variant="caption" color="text.secondary">
            Last updated by {page.updatedBy?.firstName} {page.updatedBy?.lastName} on {formatDate(page.updatedAt)}
          </Typography>
        )}
      </Box>
    </Paper>
  );
}

export default PageViewer; 